<template>
  <div class="container my-5 newsroom">
    <div class="text-center title-au font-weight-bold mb-4">Newsroom</div>
   <div class="row">
       <div class="col-md-6">
       <h1 class="news-article">
        <a href="https://www.hollywoodreporter.com/movies/movie-news/demand-cinema-platform-launched-by-tech-firm-gdc-1198923/" target="_blank">
    CinemaCon: On-Demand Cinema Platform Launched by Tech Firm GDC
    </a>
    <p>
        <span class="news-article-text">
            Digital cinema tech supplier GDC Technology is launching its GoGoCinema on-demand cinema platform and web-based booking app in the second half of the year, the company announced Tuesday at theater owners confab CinemaCon in Las Vegas.</span> <span class="readmore">
            <a href="https://www.hollywoodreporter.com/movies/movie-news/demand-cinema-platform-launched-by-tech-firm-gdc-1198923/" target="_blank">
                ...read more
            </a>
        </span>
    </p>
   </h1>
   </div>
   <div class="col-md-6">
       <h1  class="news-article">
        <a href="
    https://celluloidjunkie.com/wire/gdc-technology-announces-ubernization-of-cinema-with-gogocinema/
    " target="_blank">
    GDC Technology Announces Ubernization of Cinema with GOGOCINEMA
    </a>
    <p>
        <span class="news-article-text">
            GOGOCINEMA makes it possible for audience to enjoy all genres of movies, current or past-releases from independent films to major blockbusters on the big screen, when and where they want.</span><span class="readmore">
            <a href="https://celluloidjunkie.com/wire/gdc-technology-announces-ubernization-of-cinema-with-gogocinema/" target="_blank">
                ...read more
            </a>
        </span>
    </p>
   </h1>
   </div>
  <div class="col-md-6">
       <h1  class="news-article">
        <a href="https://www.dcinematoday.com/dc/pr?newsID=5430" target="_blank">
    GDC Technology Announces Ubernization of Cinema with GOGOCINEMA
    </a>
    <p>
        <span class="news-article-text">
            GDC Technology Limited, a leading global provider of digital cinema solutions announced today at CinemaCon it is launching the GOGOCINEMATM On-Demand-Platform and its App in the second half of this 2019.</span> <span class="readmore">
            <a href="https://www.dcinematoday.com/dc/pr?newsID=5430" target="_blank">
                ...read more
            </a>
        </span>
    </p>
   </h1>
  </div>
  <div class="col-md-6">
      <h1  class="news-article">
        <a href="
    https://www.boxofficepro.com/gdc-technology-golden-screen-cinemas-partner-to-launch-gogocinema/
    " target="_blank">
    GDC Technology, Golden Screen Cinemas Partner to Launch GoGoCinema
    </a>
    <p>
         <span class="news-article-text">
             GDC Technology Limited (‘GDC’), a leading global provider of digital cinema solutions, announced today at CineEurope 2019 that it signed a Memorandum of Understanding (MoU) with Golden Screen Cinemas Sdn. Bhd. (‘GSC’) to launch GOGOCINEMA™, its Cinema-On-Demand platform.  GoGoCinema is an intuitive and easy-to-use digital platform which is backed by GDC’s innovative Cinema Automation 2.0 (CA2.0) solution.
         </span>
         <span class="readmore">
             <a href="https://www.boxofficepro.com/gdc-technology-golden-screen-cinemas-partner-to-launch-gogocinema/" target="_blank">
                 ...read more
             </a>
         </span>
    </p>
  </h1>
  </div>
   </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "newsroom",

  data() {
    return {};
  },
  mounted(){
      const articles = document.querySelectorAll(".news-article");
      articles && articles.forEach((article)=>{
        if(article){
            const content = article.querySelector(".news-article-text");
        content.innerText = content.innerText.slice(0, 200);
        }
      })
  }
  
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pages/NewsRoom.vue